<template>
  <div class="container" v-show="isShow">
    <div class="content">
      <!-- <img class="img" src="../../assets/img/loading.gif" alt="加载"> -->
      <div class="outer"></div>
      <div class="inner"></div> 

      <!-- <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        style="
          margin: auto;
          background: none;
          display: block;
          shape-rendering: auto;
          animation-play-state: running;
          animation-delay: 0s;
        "
        width="100%"
        height="100%"
        viewBox="0 0 100 100"
        preserveAspectRatio="xMidYMid"
      >
        <circle
          cx="50"
          cy="50"
          r="0"
          fill="none"
          stroke="#e98d0c"
          stroke-width="2"
          style="animation-play-state: running; animation-delay: 0s"
        >
          <animate
            attributeName="r"
            repeatCount="indefinite"
            dur="1s"
            values="0;40"
            keyTimes="0;1"
            keySplines="0 0.2 0.8 1"
            calcMode="spline"
            begin="0s"
            style="animation-play-state: running; animation-delay: 0s"
          ></animate>
          <animate
            attributeName="opacity"
            repeatCount="indefinite"
            dur="1s"
            values="1;0"
            keyTimes="0;1"
            keySplines="0.2 0 0.8 1"
            calcMode="spline"
            begin="0s"
            style="animation-play-state: running; animation-delay: 0s"
          ></animate>
        </circle>
        <circle
          cx="50"
          cy="50"
          r="0"
          fill="none"
          stroke="#6fa343"
          stroke-width="2"
          style="animation-play-state: running; animation-delay: 0s"
        >
          <animate
            attributeName="r"
            repeatCount="indefinite"
            dur="1s"
            values="0;40"
            keyTimes="0;1"
            keySplines="0 0.2 0.8 1"
            calcMode="spline"
            begin="-0.5s"
            style="animation-play-state: running; animation-delay: 0s"
          ></animate>
          <animate
            attributeName="opacity"
            repeatCount="indefinite"
            dur="1s"
            values="1;0"
            keyTimes="0;1"
            keySplines="0.2 0 0.8 1"
            calcMode="spline"
            begin="-0.5s"
            style="animation-play-state: running; animation-delay: 0s"
          ></animate>
        </circle>
      </svg> -->
      
    </div>
  </div>
</template>

<script>
export default {
  name: "Loading",
  data() {
    return {
      title: "正在加载",
      isShow: false,
    };
  },
};
</script>

<style lang="scss" scoped>
.container {
  position: absolute;
  z-index: 9999;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.content {
  position: relative;
  width: 200px;
  height: 200px;
  border-radius: 20px;
  background-color: rgba(0, 0, 0, 0.8);
}
.outer,
.inner,
.img {
  position: absolute;
}

.outer {
  width: 150px;
  height: 150px;
  top: 25px;
  left: 25px;
  border: 2px solid #fff;
  box-sizing: border-box;
  border-radius: 50%;
  animation: anticlockwiseRotation 0.6s linear infinite;
  border-left: 1px solid transparent;
}

.inner {
  width: 100px;
  height: 100px;
  left: 50px;
  top: 50px;
  border: 2px solid #fff;
  box-sizing: border-box;
  border-radius: 50%;
  animation: clockwiseRotation 0.6s linear infinite;
  border-right: 1px solid transparent;
}

.img {
  width: auto;
  height: 50px;
  top: 80px;
  left: 75px;
  animation: bounce 0.6s linear infinite alternate;
}

@keyframes clockwiseRotation {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

@keyframes anticlockwiseRotation {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(-360deg);
  } 
}

@keyframes bounce {
  from {
    top: 80px;
  }
  to {
    top: 70px;
  }
}
</style>